"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var variables_1 = require("../variables");
var configuration_1 = require("../configuration");
var AnalyticService = (function () {
    function AnalyticService(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new http_1.HttpHeaders();
        this.configuration = new configuration_1.Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    AnalyticService.prototype.canConsumeForm = function (consumes) {
        var form = 'multipart/form-data';
        for (var _i = 0, consumes_1 = consumes; _i < consumes_1.length; _i++) {
            var consume = consumes_1[_i];
            if (form === consume) {
                return true;
            }
        }
        return false;
    };
    AnalyticService.prototype.apiAnalyticCompanyCompanyIdThresholdGatewayOnlineHoursThresholdDeviceOnlineHoursLimitHistoryDaysGet = function (companyId, thresholdGatewayOnlineHours, thresholdDeviceOnlineHours, limitHistoryDays, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiAnalyticCompanyCompanyIdThresholdGatewayOnlineHoursThresholdDeviceOnlineHoursLimitHistoryDaysGet.');
        }
        if (thresholdGatewayOnlineHours === null || thresholdGatewayOnlineHours === undefined) {
            throw new Error('Required parameter thresholdGatewayOnlineHours was null or undefined when calling apiAnalyticCompanyCompanyIdThresholdGatewayOnlineHoursThresholdDeviceOnlineHoursLimitHistoryDaysGet.');
        }
        if (thresholdDeviceOnlineHours === null || thresholdDeviceOnlineHours === undefined) {
            throw new Error('Required parameter thresholdDeviceOnlineHours was null or undefined when calling apiAnalyticCompanyCompanyIdThresholdGatewayOnlineHoursThresholdDeviceOnlineHoursLimitHistoryDaysGet.');
        }
        if (limitHistoryDays === null || limitHistoryDays === undefined) {
            throw new Error('Required parameter limitHistoryDays was null or undefined when calling apiAnalyticCompanyCompanyIdThresholdGatewayOnlineHoursThresholdDeviceOnlineHoursLimitHistoryDaysGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/Analytic/company/" + encodeURIComponent(String(companyId)) + "/" + encodeURIComponent(String(thresholdGatewayOnlineHours)) + "/" + encodeURIComponent(String(thresholdDeviceOnlineHours)) + "/" + encodeURIComponent(String(limitHistoryDays)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    AnalyticService = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Optional()), __param(1, core_1.Inject(variables_1.BASE_PATH)), __param(2, core_1.Optional()),
        __metadata("design:paramtypes", [http_1.HttpClient, String, configuration_1.Configuration])
    ], AnalyticService);
    return AnalyticService;
}());
exports.AnalyticService = AnalyticService;
//# sourceMappingURL=analytic.service.js.map